export const CONFIG_CATALOG = {
    "256": "Input Equate",
    "257": "Speed Trigger Controls - Speed Threshold",
    "258": "Speed Trigger Controls - Debounce Timer",
    "259": "Speed Trigger Controls - Delay Speed Below Timer",
    "260": "Speed Trigger Controls - Delay Speed Above Timer",
    "261": "Zone Definition",
    "262": "Time-Distance Profile - Time Elapsed",
    "263": "Time-Distance Profile - Distance Travelled",
    "264": "Time-Distance Profile - Heading Change",
    "265": "Timer Timeout",
    "266": "Accumulator Threshold",
    "267": "Time of Day Setting - Time",
    "268": "Time of Day Setting - Repeat Interval",
    "269": "Day of Week",
    "270": "Input Trigger Controls - Debounce Timer",
    "271": "Input Trigger Controls - Delay Input High Timer",
    "272": "Input Trigger Controls - Delay Input Low Timer",
    "273": "Environment Mask",
    "275": "Time-Distance Profile - Minimum Time Interval",
    "276": "A/D Threshold",
    "277": "Acceleration - Acceleration Threshold",
    "278": "Acceleration - Speed Sample Rate",
    "279": "Accumulator Type Designation",
    "280": "Accumulator Index",
    "281": "Acceleration Source Selection",
    "282": "Acceleration AVG Window",
    "283": "Acceleration Threshold",
    "284": "Acceleration Minimum Duration",
    "285": "Acceleration Maximum Duration",
    "286": "Schedule Window",
    "287": "TPRAMS Condition Group",
    "291": "Input Timer Scale",
    "292": "Audio Detect Threshold",
    "293": "Audio Detect Duration",
    "294": "Accumulator Map Start",
    "295": "Number of rows for Accumulator Map Matrix",
    "296": "Accumulator Source for Matrix distance",
    "297": "Accumulator Matrix row data source",
    "298": "Accumulator Matrix row High Threshold array",
    "299": "Accumulator Matrix row LOW Threshold array",
    "300": "PEG Time\u00e2\u20ac\u2018Distance Profile options",
    "512": "Event Record",
    "513": "Event Record Page 2",
    "514": "Event Record Page 3",
    "515": "Event Record Page 4",
    "768": "Inbound IP Address List",
    "769": "Inbound Port List",
    "770": "Accumulator Reporting - Accumulator Count by Event Code",
    "771": "Inbound Retry Schedule (Seconds)",
    "772": "Inbound Event Report Contents",
    "773": "Logged Event Report Contents",
    "774": "Inbound Local Port",
    "775": "Reporting Profile Comm Route",
    "776": "Reporting Profile Accumulator Format",
    "777": "Reporting Profile Mapped Accumulators",
    "778": "Log Message Limit",
    "779": "Reporting Event Table",
    "780": "TCP Inactive Timeout",
    "781": "Accum. Message Type",
    "782": "Accum. To Add",
    "783": "Inbound Reporting Accumulator Map-256",
    "784": "Inbound Server Socket IP mode",
    "785": "Inbound App message 256 accumulator map",
    "786": "Inbound User message 256 accumulator map",
    "787": "Inbound IP Mode",
    "788": "Inbound retransmission schedule by comm route",
    "791": "Inbound Event Report Table Expanded Route",
    "902": "ACCEL Impact Threshold",
    "903": "ACCEL Impact Duration",
    "904": "ACCEL Impact Reference Period",
    "905": "ACCEL Motion Threshold",
    "906": "ACCEL Motion Reference Period",
    "907": "ACCEL Motion Poll Period",
    "908": "ACCEL Motion State Change Count",
    "909": "ACCEL Alignment Configuration",
    "910": "ACCEL Tilt Configuration",
    "911": "ACCEL Tilt Angle Threshold",
    "912": "ACCEL Motion Range",
    "913": "Accel Impact Forward",
    "1024": "S-Register",
    "1025": "Service Enables",
    "1026": "MDT Enables",
    "1027": "GPS Lost Timeout",
    "1028": "GPS Last Known Timeout",
    "1029": "Input Wake-Up Monitor",
    "1030": "Local Timezone",
    "1031": "Log Retry Timer (Ignition On)",
    "1032": "Log Retry Attempts (Ignition On)",
    "1033": "Log Retry Timer (Ignition Off)",
    "1034": "Log Retry Attempts (Ignition Off)",
    "1035": "Moving Speed Threshold",
    "1036": "User Flag",
    "1037": "PEG Enables",
    "1038": "TTU Not-In-Motion (Low) Threshold",
    "1039": "TTU In-Motion (High) Threshold",
    "1040": "TTU In-Motion Max Count",
    "1041": "TTU Motion Detect Window (seconds, up to 30)",
    "1043": "Motion Log Sample Interval (seconds)",
    "1044": "Timezone Offset (minutes)",
    "1045": "Daylight Savings Time Rule",
    "1046": "Daylight Savings",
    "1047": "Towing",
    "1048": "Long Log Type",
    "1049": "Short Log Type",
    "1050": "Short Log Frequency",
    "1051": "Short Log Configuration",
    "1052": "PEG Enables Extension",
    "1053": "RPM Calibration",
    "1054": "Driver ID",
    "1055": "Ignition State Transition",
    "1056": "Battery Voltage Sampling Rate",
    "1060": "RPM calibration divisor (see Param 1053)",
    "1061": "Motion Log Size",
    "1062": "Compression Version",
    "1063": "LMDirect Compression Type",
    "1064": "Wake on serial stream activity",
    "1066": "Alternate wakeup monitor",
    "1067": "TTU Sleep Current Discharge Override Value",
    "1068": "Comm Mode",
    "1069": "Reject FW system time sync from various source",
    "1070": "STM32L471 DAC output configuration",
    "1071": "Minimum Processing Period",
    "1072": "Low Power Processing Period",
    "1073": "Sleep Process Enables",
    "1074": "Auxiliary Modem Type for 3 radio comm. modes",
    "1075": "Lon Log Accumulator Enables",
    "1076": "Controls GPS reporting format in inbound LM Direct messages",
    "1077": "GPS receiver power mask",
    "1078": "3640 Buzzer Volume Percentage",
    "1079": "Cranking Monitoring Period",
    "1080": "One bit bus temperature sensor",
    "1280": "Access Enables",
    "1281": "Access IP Address List",
    "1282": "Remote Host IP Address List",
    "1283": "Primary Port Password",
    "1536": "Network Discriminant - Type",
    "1537": "Network Discriminant - Condition",
    "1538": "Network Discriminant - Value",
    "1539": "Network Side Preference (CDPD Only)",
    "1540": "Network Sleep Settings (CDPD Only)",
    "2080": "Bluetooth Name",
    "2081": "Bluetooth PIN",
    "2082": "Remote Address in HEX",
    "2083": "Low Engery Mode",
    "2084": "FOB Config",
    "2086": "Bluetooth Low Energy Advertising Interval",
    "2087": "Bluetooth Gatekeeper Authorization enable",
    "2090": "BLE FOB minimum advert RSSI",
    "2176": "Text String - Long",
    "2177": "Text String - Short",
    "2178": "Serial Msg Detection",
    "2179": "Serial Messages Destination Streams",
    "2306": "GPRS Context String",
    "2307": "GPRS Context - Current Index",
    "2310": "Maintenance Message Inbound IP Address",
    "2311": "Maintenance Message Inbound Port",
    "2312": "Maintenance Message Configuration",
    "2313": "Null Message Interval",
    "2319": "Inbound URL",
    "2320": "Maintenance URL",
    "2322": "Maintenance Message Interval",
    "2327": "Maintance Retry schedule",
    "2328": "Debug Log URL",
    "2330": "Maintenance Server Socket IP mode",
    "2332": "TCP Max Segment Size",
    "2688": "Hosted Apps Byte",
    "2689": "Hosted Apps Short",
    "2690": "Hosted Apps Long",
    "2693": "Hosted Apps UDP Port",
    "2816": "Assist Latitude",
    "2817": "Assist Longitude",
    "2818": "Assist Server URL",
    "2819": "Assist Server IP Address",
    "2820": "Assist Server Port",
    "2821": "Assist Server UserName",
    "2822": "Assist Server Password",
    "2823": "Assist Server Request 0=aiding, 1=full",
    "2824": "Assist Initial Position Accuracy",
    "2825": "Assist Server Update Latency in 0.1 seconds",
    "3072": "Port Assignment",
    "3073": "Port Bit Rate",
    "3074": "Port Word Definition",
    "3200": "WIFI Profile Selection",
    "3201": "WIFI Station Selection",
    "3202": "WIFI Encryption Selection",
    "3203": "WIFI IP Mode Selection (DHCP, Assigned)",
    "3204": "WIFI Encryption Key Index",
    "3208": "WIFI Assigned IP Address",
    "3209": "WIFI Assigned Netmask",
    "3210": "WIFI Assigned Default Route IP Address",
    "3211": "WIFI Assigned IP Address of Name Server",
    "3214": "WiFi RSSI Threshold",
    "3215": "Wifi RSSI Timeout",
    "3216": "WiFi Data Rate Mask",
    "3217": "WiFi Net Up Timeout",
    "3328": "Vehicle Bus Parameter ID",
    "3329": "Vehicle Bus Indicator ID",
    "3330": "Vehicle Bus Indicator Enables BitMap",
    "3332": "Vehicle Bus Ignition On Voltage Threshold",
    "3333": "Vehicle Bus Parameter Sampling Interval",
    "3334": "Vehicle Bus Voltage Differential",
    "3335": "Vehicle Bus Sampling Interval (1ms LSB)",
    "3336": "OBD Power On Hold Off",
    "3337": "Power On Hold Off - RPM Below Threshold",
    "3338": "Power On Hold Off - Delay",
    "3339": "Power On Hold Off - Duration - detected",
    "3340": "Power On Hold Off - Duration - not detected",
    "3341": "Sample Interval (1/10 millisecond)",
    "3342": "Reads Before Ignition Off",
    "3343": "SQRL Termination character",
    "3345": "VBus MISC Switches",
    "3346": "JPOD Param Length",
    "3347": "Engine Displacement",
    "3348": "Fuel Rate Scaling Factor",
    "3349": "Fuel Rate Offset Value",
    "3350": "Vehicle Bus Shared Options",
    "3351": "Low battery voltage threshold",
    "3352": "The combined image VBUS auto-detection selection parameter.",
    "4080": "GPS GNSSID Mode",
    "897": "ACCEL Motion Impact CFG1",
    "2318": "PRL Dial String",
    "2560": "Accumulator Value",
    "3331": "DTC Filter Text",
    "896": "ACCEL Motion Mode",
    "898": "ACCEL Motion Impact CGF2",
    "899": "ACCEL Motion Period",
    "900": "ACCEL Motion Interval",
    "901": "ACCEL Motion Threshold",
    "2316": "Packet Dial String"
}